import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import KMI from './KMI'
import Modal from '../../2_Molecules/Modal/Modal'

const KMIModal = ({
  formExtraParams
}) => {
  const { formImage, isPopUp, ...restParams } = formExtraParams;
  const isPopUpBoolean = (isPopUp && isPopUp.toLowerCase() === 'true');
  const modalRef = useRef(null);

  return (
    <Modal
      className={`mz-kmi-modal ${isPopUpBoolean ? 'mz-popup-modal' : ''}`}
      style={{ backgroundImage: formImage ? `url(${formImage})` : '' }}
      isDark={true}
      modalRef={modalRef}
    >
      <KMI
        formExtraParams={restParams}
      />
    </Modal>
  )
}

KMIModal.propTypes = {
  formExtraParams: PropTypes.object.isRequired
}

export default KMIModal

